const translate = (viewBag, dictionaryItem, fallBack = null) => {
  if (viewBag?.dictionary) {
    return viewBag?.dictionary?.[dictionaryItem] || fallBack;
  }
  return fallBack;
};

export default translate;
